@use '@swisspost/design-system-styles/variables/color';
@use '../../utils/utils.scss';
@use '../../utils/mixins.scss';

:host {
  display: block;
}

.logo {
  display: block;
  align-items: center;
  background: color.$yellow;

  svg {
    display: block;
    width: var(--header-height);
    height: var(--header-height);
  }
}
